<template>
  <div class="box-card">
    <el-row :gutter="12">
      <el-col :span="19">
        <span class="title">List列表导入</span>
      </el-col>
    </el-row>
    <div style="border-top:1px solid #DCDFE6;margin-top: 30px;">
      <!-- <button @click="getInfo">
        Agile列表导入
      </button> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {};
  },
  methods: {
    getInfo() {
      axios.get("pmdm/agile/buildAndSaveListFromAgile").then((res) => {
        console.log(res);
      });
    },
    confirm() {
      this.$confirm(
        // this.$t("message.confirm.closeAllTabs"),
        '将从Agile系统导入list,已存在的值将会被覆盖,请确定？',
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          var tabs = this.$store.getters.getShowingTabInHome; //已存在的list数据
          var activeName = this.$store.getters.getActivedTabInHome;
          if (tabs.length < 2) {
            this.$message({
              message: this.$t("message.tips.tab"),
              type: "warning",
            });
            return false;
          } else {
            let res = tabs.find((i) => i.name === activeName);
            this.$store.commit("clearShowingTabsInHome");
            this.$store.commit("setShowingTabsInHome", res);

            this.$message({
              type: "success",
              message: this.$t("message.tips.closeSucess"),
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.cancel"),
          });
        });
    },
  },
  created() {
    this.confirm();
  },
};
</script>
<style scoped>
.box-card {
  /* width: 100%; */
  /* height: 660px; */
  padding: 20px;
  background: #fff;
}
.title {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  font-size: 18px;
  height: 18px;
  line-height: 18px;
}
</style>
